module.exports = __webpack_public_path__ + "media/images/icons/icon-success-large-89f85f15ed53493d28ebc5254d120d2d.svg";